import { render, staticRenderFns } from "./priceRuleItem.vue?vue&type=template&id=b3d41a16&scoped=true&"
import script from "./priceRuleItem.vue?vue&type=script&lang=js&"
export * from "./priceRuleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d41a16",
  null
  
)

export default component.exports